import { WorkItem } from "@wingspanhq/wingspan-api-sdk";
import { filterActiveWorkItems } from "../utils/filterActiveWorkItems";

type Params = {
  /** The work log's items. Callers should already have asked for active ones. */
  workItems?: WorkItem[];
  attachmentsRequired: boolean;
  attachmentCount: number;
};

/**
 * Why the contractor cannot submit this work log for review, or `undefined`
 * when they can, so the disabled action can say why instead of letting the call
 * fail.
 *
 * The two reasons are not equally authoritative. The empty-log rule is the
 * server's own — `workLogTransitionService` counts *active* items, which is why
 * this filters too: a removed item lingers as `INACTIVE`, so a log whose items
 * have all been removed still has a non-empty raw list (PLA-3662). The
 * attachment rule has no server counterpart in the submit path; it is the
 * client honoring the payer's `requireAttachments` config on its own.
 */
export const selectorWorkLogSubmitBlockedReason = (
  params: Params
): string | undefined => {
  if (filterActiveWorkItems(params.workItems ?? []).length === 0) {
    return "Add at least one work item before submitting this work log.";
  }

  if (params.attachmentsRequired && params.attachmentCount === 0) {
    return "This client requires an attachment before a work log can be submitted.";
  }

  return undefined;
};
